// extracted by mini-css-extract-plugin
export var accordion = "_bq-0";
export var chevron = "_bq-3";
export var closed = "_bq-2";
export var content = "_bq-4";
export var open = "_bq-1";
export var rotate = "_bq-5";